/**
 * G5-T34.4: postMessage protokolü — embed mod için host ↔ DataScope iletişimi.
 *
 * Host → DataScope (gelen mesajlar):
 *   { type: 'DS_NAVIGATE', path: '/rules' }
 *   { type: 'DS_SET_THEME', theme: 'dark' | 'light' }
 *
 * DataScope → Host (gönderilen mesajlar):
 *   { type: 'DS_READY' }
 *   { type: 'DS_NAVIGATE', path: '/rules' }
 *   { type: 'DS_ERROR', message: '...' }
 *   { type: 'DS_RESIZE', height: 600 }
 */

export const MSG = {
  NAVIGATE:  'DS_NAVIGATE',
  SET_THEME: 'DS_SET_THEME',
  READY:     'DS_READY',
  ERROR:     'DS_ERROR',
  RESIZE:    'DS_RESIZE',
};

/**
 * Host'a mesaj gönderir (parent window).
 * @param {string} type  - MSG sabitlerinden biri
 * @param {object} payload
 */
export function postToHost(type, payload = {}) {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({ type, ...payload }, '*');
  }
}

/**
 * Host'tan gelen mesajları dinler.
 * @param {function} handler - (message: {type, ...}) callback
 * @returns {function} unlisten — çağrılınca listener'ı kaldırır
 */
export function listenFromHost(handler) {
  const listener = (event) => {
    if (event.data && typeof event.data.type === 'string' && event.data.type.startsWith('DS_')) {
      handler(event.data);
    }
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
